export const generateRouteWithParam = (route: string, userId: string | number) => {
  const basicRoute = route.substring(0, route.indexOf(':'));
  return `${basicRoute}${userId}`;
};
